import React from "react";
import Header from "../components/Header";
import Layout from "../components/Layout";
import PolicyCard from "../components/PolicyCard";
import Container from '@mui/material/Container';
import PolicyDetails from "../components/PolicyDetails";
import AdditionalInfo from "../components/AdditionalInfo";
import LoanCard from "../components/LoanCard";
import AssignmentCard from "../components/Assignment";
import PremiumFinancingCard from "../components/PremiumFinancingCard";
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import RevivalOption from "../components/RevivalOption";
import Graph from "../components/Graph";
import KycRequirement from "../components/KycRequirement";

const Login = () => {
    const policy = {
        policyNumber: "NN012403234799",
        policyHolderName: "YASHWANTH V S",
        savingType: "Traditional",
        policyStatus: "Inforce",
        logo: "/images/shriram-logo.png",
        planName: "Max Life Smart Wealth Plan",
        premium: "1,00,000",
        commencementDate: "15-6-2021",
        policyTerm: "10 Years",
        paymentTerm: "10 Years",
        totalPremiumPaid: "₹ 80,123",
        pendingPremium: "₹ 40,345",
        accruedBonus: "₹ 10,545",
        paidUpValue: "₹ 2,00,123",
        maturityDate: "20-02-2028",
        liquidationDate: "20-02-2028",
        approxBonusAmt: "₹ 3,895",
        approxMaturityAmt: "₹ 3,895",
        fundValue:"₹ 3,00,895",
        additionalInfo: [
            {
                name: "Total Premium Paid",
                value: "₹ 80,895"
            },
            {
                name: "Approx. Maturity Amount",
                value: "₹ 1,10,895"
            },
            {
                name: "Total Premium Paid",
                value: "₹ 10,895"
            },
            {
                name: "Expected Bonus",
                value: "₹ 3,895"
            },
        ],
        loanInfo: {
            loanInterest: '18%',
            loanOnInsuranceProcessingFee: '₹ 3,000',
            emi: [
                {
                    tenure: '12 M',
                    amount: '₹ 14,561'
                },
                {
                    tenure: '24 M',
                    amount: '₹ 29,122'
                },
                {
                    tenure: '36 M',
                    amount: '₹ 43,548'
                },
            ]
        }
    }
    return (
        <Layout>
            <Container maxWidth="sm" className="layoutcontainer">
                <PolicyCard policy={policy} />
                <PolicyDetails policy={policy} />
                <AdditionalInfo policy={policy} />
                {policy.savingType == "ULIP" && savingType.policyStatus != "Inforce" && (
                    <Graph></Graph>
                )}
                <Paper elevation={3} style={{paddingTop:30, paddingBottom:30, paddingLeft:24, paddingRight:24, backgroundColor:'#FAFAFA',borderColor:'#FAFAFA', borderWidth:1, borderStyle:'solid', borderRadius:8, marginTop:30}}>
                    <div mb={8}>
                    <Typography color='#4DA235' variant='h5'>Congratulations !</Typography>
                    <Typography variant='caption'>YOUR POLICY ELIGIBLE FOR</Typography>
                    </div>
                    <LoanCard policy={policy} />
                    <AssignmentCard policy={policy} />
                    <PremiumFinancingCard policy={policy} />
                    <RevivalOption policy={policy} />
                </Paper>
                <KycRequirement />
            </Container>
        </Layout>
    )
}

export default Login;
